<template>
  <a-drawer
    :title="drawerTitle"
    width="720"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="touchCancel"
  >
    <a-spin :spinning="isDetailLoading">
      <a-form
        ref="RefForm"
        :model="formState"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-divider orientation="left">基础信息</a-divider>
        <a-form-item label="快手账号" name="kdj_account_id" :rules="[{ required: true, message: '请选择快手账号' }]">
          <a-select v-model:value="formState.kdj_account_id" placeholder="请选择" allow-clear>
            <a-select-option v-for="item in KdjAccountOptions" :key="item.value" :value="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="情节" name="kdj_plot" :rules="[{ required: true, message: '请选择情节' }]">
          <a-select v-model:value="formState.kdj_plot" mode="multiple" placeholder="请选择" allow-clear>
            <a-select-option v-for="item in plotOptions" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="标签" name="kdj_tag" :rules="[{ required: true, message: '请选择标签' }]">
          <a-select v-model:value="formState.kdj_tag" mode="multiple" placeholder="请选择" allow-clear>
            <a-select-option v-for="item in tagOptions" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="整剧价格" name="kdj_price" :rules="[{ required: true, validator: validatorKdjPrice }]">
          <a-input-number
            v-model:value="formState.kdj_price"
            :min="0.1"
            :max="99999"
            :precision="2"
            style="width: 100%;"
            placeholder="单位：元，0.1~99999"
            addon-after="元"
          />
        </a-form-item>
        <a-form-item label="单集价格" name="kdj_price_episode" :rules="[{ required: true, validator: validatorKdjEpisodePrice }]">
          <a-input-number
            v-model:value="formState.kdj_price_episode"
            :min="0.1"
            :max="100"
            :precision="2"
            style="width: 100%;"
            placeholder="单位：元，0.1~100"
            addon-after="元"
          />
        </a-form-item>

        <a-form-item
          v-if="detailHasCopyrightProof"
          label="版权证明类型"
          name="kdj_copyright_proof_type"
          :rules="[{ required: true, message: '请选择版权证明类型' }]"
        >
          <a-select v-model:value="formState.kdj_copyright_proof_type" placeholder="请选择" allow-clear>
            <a-select-option v-for="item in KdjCopyrightTypes" :key="item.value" :value="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-divider orientation="left">备案信息</a-divider>
        <a-form-item label="是否有备案号" name="is_record" :rules="[{ required: true, message: '请选择是否有备案号' }]">
          <a-radio-group v-model:value="formState.is_record">
            <a-radio v-for="item in FilingTypes" :key="item.value" :value="item.value">{{ item.text }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <template v-if="hasFilingNo">
          <a-form-item label="备案号类型" name="kdj_filing_no_type" :rules="[{ required: true, message: '请选择备案号类型' }]">
            <a-select v-model:value="formState.kdj_filing_no_type" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in KdjFilingNoTypes" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="备案号" name="kdj_filing_no" :rules="[{ required: true, message: '请输入备案号' }]">
            <a-input v-model:value="formState.kdj_filing_no" placeholder="请按平台规则填写备案号" />
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item label="导演名称" name="directors" :rules="requiredNameRules('导演名称')">
            <a-input v-model:value="formState.directors" placeholder="请输入" />
          </a-form-item>
          <a-form-item label="导演性别" name="directors_gender" :rules="requiredGenderRules('导演性别')">
            <a-select v-model:value="formState.directors_gender" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in ActorGenders" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="编剧名称" name="screen_writer" :rules="requiredNameRules('编剧名称')">
            <a-input v-model:value="formState.screen_writer" placeholder="请输入" />
          </a-form-item>
          <a-form-item label="编剧性别" name="screen_writer_gender" :rules="requiredGenderRules('编剧性别')">
            <a-select v-model:value="formState.screen_writer_gender" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in ActorGenders" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="制片人名称" name="producer" :rules="requiredNameRules('制片人名称')">
            <a-input v-model:value="formState.producer" placeholder="请输入" />
          </a-form-item>
          <a-form-item label="制片人性别" name="producer_gender" :rules="requiredGenderRules('制片人性别')">
            <a-select v-model:value="formState.producer_gender" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in ActorGenders" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </template>

        <a-divider orientation="left">版权材料</a-divider>
        <a-form-item label="版权类型" name="kdj_copyright_type" :rules="[{ required: true, message: '请选择版权类型' }]">
          <a-select v-model:value="formState.kdj_copyright_type" placeholder="请选择" allow-clear>
            <a-select-option v-for="item in KdjCopyrightTypes" :key="item.value" :value="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <template v-if="needAuthMaterial">
          <a-form-item
            label="授权推广文件"
            name="kdj_authorized_material"
            :rules="[{ required: true, validator: validatorFileList('kdj_authorized_material') }]"
          >
            <a-form-item-rest>
              <Upload
                accept=".pdf,.jpg,.jpeg,.png"
                uploadSource="KdjAuthorized"
                :multiple="true"
                :uploadResult="() => {}"
                :fileList="formState.kdj_authorized_material"
                :uploadBucket="$pub.BUCKET_PUB()"
              />
            </a-form-item-rest>
            <FileListPreview :list="formState.kdj_authorized_material" @delete="(i) => touchDeleteFile('kdj_authorized_material', i)" />
          </a-form-item>
          <a-form-item
            label="版权有效期开始"
            name="kdj_copyright_start_time"
            :rules="[{ required: true, message: '请选择版权有效期开始时间' }]"
          >
            <a-date-picker
              show-time
              style="width: 100%;"
              v-model:value="formState.kdj_copyright_start_time"
              format="YYYY-MM-DD HH:mm:ss"
              :getPopupContainer="(t) => t.parentNode"
            />
          </a-form-item>
          <a-form-item
            label="版权有效期结束"
            name="kdj_copyrigh_end_time"
            :rules="[{ required: true, message: '请选择版权有效期结束时间' }]"
          >
            <a-date-picker
              show-time
              style="width: 100%;"
              v-model:value="formState.kdj_copyrigh_end_time"
              format="YYYY-MM-DD HH:mm:ss"
              :getPopupContainer="(t) => t.parentNode"
            />
          </a-form-item>
          <a-form-item
            label="是否有转授权"
            name="kdj_has_sub_authorized"
            :rules="[{ required: true, message: '请选择是否有转授权权利' }]"
          >
            <a-radio-group v-model:value="formState.kdj_has_sub_authorized">
              <a-radio v-for="item in KdjBoolOptions" :key="String(item.value)" :value="item.value">{{ item.text }}</a-radio>
            </a-radio-group>
          </a-form-item>
        </template>
        <a-form-item label="材料类型" name="kdj_material_type" :rules="[{ required: true, message: '请选择材料类型' }]">
          <a-select v-model:value="formState.kdj_material_type" placeholder="请选择" allow-clear>
            <a-select-option v-for="item in KdjMaterialTypes" :key="item.value" :value="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="needKdjFile"
          label="材料文件"
          name="kdj_file"
          :rules="[{ required: true, validator: validatorFileList('kdj_file') }]"
        >
          <a-form-item-rest>
            <Upload
              accept=".pdf,.jpg,.jpeg,.png"
              uploadSource="KdjFile"
              :multiple="true"
              :uploadResult="() => {}"
              :fileList="formState.kdj_file"
              :uploadBucket="$pub.BUCKET_PUB()"
            />
          </a-form-item-rest>
          <FileListPreview :list="formState.kdj_file" @delete="(i) => touchDeleteFile('kdj_file', i)" />
        </a-form-item>
        <a-form-item
          v-if="needCommitmentLetter"
          label="承诺书"
          name="kdj_commitment_letter"
          :rules="[{ validator: validatorOptionalFileList('kdj_commitment_letter') }]"
        >
          <a-form-item-rest>
            <Upload
              accept=".pdf,.jpg,.jpeg,.png"
              uploadSource="KdjCommitment"
              :multiple="true"
              :uploadResult="() => {}"
              :fileList="formState.kdj_commitment_letter"
              :uploadBucket="$pub.BUCKET_PUB()"
            />
          </a-form-item-rest>
          <FileListPreview :list="formState.kdj_commitment_letter" @delete="(i) => touchDeleteFile('kdj_commitment_letter', i)" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template #footer>
      <a-button style="margin-right: 8px" @click="touchCancel">取消</a-button>
      <a-button type="primary" :loading="isLoading" @click="touchOk">保存</a-button>
    </template>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, computed, defineComponent, h } from 'vue'
import { message } from 'ant-design-vue'
import { PaperClipOutlined } from '@ant-design/icons-vue'
import dayjs from 'dayjs'
import Upload from '@/components/Upload'
import Pub from '@/utils/public'
import { dramaDetail, kdjSave, kdjTypeList } from '@/api/copyright'
import {
  FilingTypes,
  ActorGenders,
  KdjAccountOptions,
  KdjCopyrightTypes,
  KdjMaterialTypes,
  KdjFilingNoTypes,
  KdjBoolOptions
} from '@/utils/constant'

const $pub = Pub
const emit = defineEmits(['success'])

const FileListPreview = defineComponent({
  props: { list: { type: Array, default: () => [] } },
  emits: ['delete'],
  setup(props, { emit }) {
    return () => {
      if (!props.list?.length) return null
      return h('div', { style: 'margin-top: 8px;' }, props.list.map((item, index) =>
        h('div', { key: item.uid || index, style: 'display:flex;align-items:center;gap:8px;margin-bottom:4px;font-size:13px;' }, [
          h(PaperClipOutlined, { style: 'color:#8c8c8c;' }),
          item.url
            ? h('a', { href: item.url, target: '_blank', style: 'flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;' }, item.name || item.url)
            : h('span', { style: 'flex:1;color:#8c8c8c;' }, `${item.name || ''}（上传中...）`),
          h('a', { style: 'color:#ff4d4f;flex-shrink:0;', onClick: () => emit('delete', index) }, '删除')
        ])
      ))
    }
  }
})

const RefForm = ref(null)
const visible = ref(false)
const isLoading = ref(false)
const isDetailLoading = ref(false)
let currentRecord = null
const detailHasCopyrightProof = ref(false)
const plotOptions = ref([])
const tagOptions = ref([])

const formState = reactive({
  kdj_account_id: undefined,
  kdj_plot: [],
  kdj_tag: [],
  kdj_price: undefined,
  kdj_price_episode: undefined,
  kdj_copyright_proof_type: undefined,
  is_record: 0,
  kdj_filing_no_type: undefined,
  kdj_filing_no: undefined,
  directors: undefined,
  directors_gender: undefined,
  screen_writer: undefined,
  screen_writer_gender: undefined,
  producer: undefined,
  producer_gender: undefined,
  kdj_copyright_type: undefined,
  kdj_material_type: undefined,
  kdj_file: [],
  kdj_commitment_letter: [],
  kdj_authorized_material: [],
  kdj_copyright_start_time: undefined,
  kdj_copyrigh_end_time: undefined,
  kdj_has_sub_authorized: undefined
})

const drawerTitle = computed(() => {
  const name = currentRecord?.remark_name || currentRecord?.name
  return name ? `快手短剧创编 - ${name}` : '快手短剧创编'
})
const hasFilingNo = computed(() => formState.is_record === 1)
const needKdjFile = computed(() => [2, 3, 4, 5].includes(formState.kdj_material_type))
const needCommitmentLetter = computed(() => [3, 4].includes(formState.kdj_material_type))
const needAuthMaterial = computed(() => formState.kdj_copyright_type === 2)

function urlsToFileList(urls) {
  if (!urls || !Array.isArray(urls)) return []
  return urls.filter(Boolean).map((url, i) => ({
    uid: `saved-${i}-${url}`,
    name: url.split('/').pop() || `file-${i}`,
    status: 'done',
    url
  }))
}

function mapListToUrls(list) {
  return (list || []).filter(f => f.status === 'done' && f.url).map(f => f.url)
}

function resetForm() {
  RefForm.value?.resetFields()
  Object.assign(formState, {
    kdj_account_id: undefined,
    kdj_plot: [],
    kdj_tag: [],
    kdj_price: undefined,
    kdj_price_episode: undefined,
    kdj_copyright_proof_type: undefined,
    is_record: 0,
    kdj_filing_no_type: undefined,
    kdj_filing_no: undefined,
    directors: undefined,
    directors_gender: undefined,
    screen_writer: undefined,
    screen_writer_gender: undefined,
    producer: undefined,
    producer_gender: undefined,
    kdj_copyright_type: undefined,
    kdj_material_type: undefined,
    kdj_file: [],
    kdj_commitment_letter: [],
    kdj_authorized_material: [],
    kdj_copyright_start_time: undefined,
    kdj_copyrigh_end_time: undefined,
    kdj_has_sub_authorized: undefined
  })
  detailHasCopyrightProof.value = false
}

function fillForm(data) {
  detailHasCopyrightProof.value = !!data.has_copyright_proof
  formState.kdj_account_id = data.kdj_account_id ?? undefined
  formState.kdj_plot = Array.isArray(data.kdj_plot) ? [...data.kdj_plot] : []
  formState.kdj_tag = Array.isArray(data.kdj_tag) ? [...data.kdj_tag] : []
  formState.kdj_price = data.kdj_price !== undefined && data.kdj_price !== null ? data.kdj_price / 100 : undefined
  formState.kdj_price_episode = data.kdj_price_episode !== undefined && data.kdj_price_episode !== null ? data.kdj_price_episode / 100 : undefined
  formState.kdj_copyright_proof_type = data.kdj_copyright_proof_type ?? undefined
  formState.is_record = data.is_record !== undefined && data.is_record !== null ? data.is_record : 0
  formState.kdj_filing_no_type = data.kdj_filing_no_type ?? undefined
  formState.kdj_filing_no = data.kdj_filing_no || undefined
  formState.directors = data.directors || undefined
  formState.directors_gender = data.directors_gender || undefined
  formState.screen_writer = data.screen_writer || undefined
  formState.screen_writer_gender = data.screen_writer_gender || undefined
  formState.producer = data.producer || undefined
  formState.producer_gender = data.producer_gender || undefined
  formState.kdj_copyright_type = data.kdj_copyright_type ?? undefined
  formState.kdj_material_type = data.kdj_material_type ?? undefined
  formState.kdj_file = urlsToFileList(data.kdj_file)
  formState.kdj_commitment_letter = urlsToFileList(data.kdj_commitment_letter)
  formState.kdj_authorized_material = urlsToFileList(data.kdj_authorized_material)
  formState.kdj_copyright_start_time = data.kdj_copyright_start_time ? dayjs(data.kdj_copyright_start_time) : undefined
  formState.kdj_copyrigh_end_time = data.kdj_copyrigh_end_time ? dayjs(data.kdj_copyrigh_end_time) : undefined
  formState.kdj_has_sub_authorized = data.kdj_has_sub_authorized !== undefined && data.kdj_has_sub_authorized !== null
    ? data.kdj_has_sub_authorized
    : undefined
}

function show(record) {
  currentRecord = record
  resetForm()
  visible.value = true
  loadTypeOptions()
  getDetail(record.id)
}

defineExpose({ show })

function touchCancel() {
  if (!isLoading.value) {
    visible.value = false
  }
}

function touchDeleteFile(key, index) {
  formState[key].splice(index, 1)
  RefForm.value?.validateFields([key]).catch(() => {})
}

function requiredNameRules(label) {
  return [{ required: true, whitespace: true, message: `请输入${label}` }]
}

function requiredGenderRules(label) {
  return [{ required: true, message: `请选择${label}` }]
}

function validatorKdjPrice(_, value) {
  if (value === undefined || value === null) return Promise.reject('请输入整剧价格')
  if (value < 0.1 || value > 99999) return Promise.reject('整剧价格范围为 0.1~99999 元')
  return Promise.resolve()
}

function validatorKdjEpisodePrice(_, value) {
  if (value === undefined || value === null) return Promise.reject('请输入单集价格')
  if (value < 0.1 || value > 100) return Promise.reject('单集价格范围为 0.1~100 元')
  return Promise.resolve()
}

function validatorFileList(key) {
  return () => {
    const list = formState[key] || []
    if (list.some(f => f.status === 'uploading')) return Promise.reject('文件上传中，请稍候')
    const done = list.filter(f => f.status === 'done' && f.url)
    if (!done.length) return Promise.reject('请上传文件')
    return Promise.resolve()
  }
}

function validatorOptionalFileList(key) {
  return () => {
    const list = formState[key] || []
    if (!list.length) return Promise.resolve()
    if (list.some(f => f.status === 'uploading')) return Promise.reject('文件上传中，请稍候')
    const done = list.filter(f => f.status === 'done' && f.url)
    if (!done.length) return Promise.reject('请上传文件')
    return Promise.resolve()
  }
}

// kdj_type 返回 { plot: { "1": "豪门赘婿", ... }, tag: { "1": "脑洞", ... } }
function mapTypeObject(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return []
  return Object.entries(obj)
    .map(([key, name]) => ({ id: Number(key), name }))
    .sort((a, b) => a.id - b.id)
}

function touchOk() {
  RefForm.value?.validate().then(() => {
    const fileKeys = ['kdj_file', 'kdj_commitment_letter', 'kdj_authorized_material']
    for (const key of fileKeys) {
      if (formState[key].some(f => f.status === 'uploading')) {
        message.warning('文件上传中，请稍候再提交')
        return
      }
    }
    submitSave()
  }).catch(() => {})
}

function loadTypeOptions() {
  kdjTypeList().then(res => {
    if (res.code === 0 && res.data) {
      plotOptions.value = mapTypeObject(res.data.plot)
      tagOptions.value = mapTypeObject(res.data.tag)
    }
  }).catch(() => {})
}

function getDetail(id) {
  isDetailLoading.value = true
  dramaDetail({ id }).then(res => {
    isDetailLoading.value = false
    const { code, data } = res
    if (code === 0 && data) {
      fillForm(data)
    } else {
      message.error(res.msg || res.message || '获取详情失败')
    }
  }).catch(() => {
    isDetailLoading.value = false
    message.error('获取详情失败')
  })
}

function submitSave() {
  isLoading.value = true
  const params = {
    drama_id: currentRecord?.id,
    kdj_account_id: formState.kdj_account_id,
    kdj_plot: formState.kdj_plot,
    kdj_tag: formState.kdj_tag,
    kdj_price: formState.kdj_price !== undefined && formState.kdj_price !== null ? Math.round(formState.kdj_price * 100) : undefined,
    kdj_price_episode: formState.kdj_price_episode !== undefined && formState.kdj_price_episode !== null ? Math.round(formState.kdj_price_episode * 100) : undefined,
    is_record: formState.is_record,
    kdj_copyright_type: formState.kdj_copyright_type,
    kdj_material_type: formState.kdj_material_type
  }
  if (detailHasCopyrightProof.value) {
    params.kdj_copyright_proof_type = formState.kdj_copyright_proof_type
  }
  if (hasFilingNo.value) {
    params.kdj_filing_no_type = formState.kdj_filing_no_type
    params.kdj_filing_no = formState.kdj_filing_no
  } else {
    params.directors = formState.directors
    params.directors_gender = formState.directors_gender
    params.screen_writer = formState.screen_writer
    params.screen_writer_gender = formState.screen_writer_gender
    params.producer = formState.producer
    params.producer_gender = formState.producer_gender
  }
  if (needKdjFile.value) {
    params.kdj_file = mapListToUrls(formState.kdj_file)
  }
  if (needCommitmentLetter.value) {
    params.kdj_commitment_letter = mapListToUrls(formState.kdj_commitment_letter)
  }
  if (needAuthMaterial.value) {
    params.kdj_authorized_material = mapListToUrls(formState.kdj_authorized_material)
    params.kdj_copyright_start_time = formState.kdj_copyright_start_time?.format('YYYY-MM-DD HH:mm:ss')
    params.kdj_copyrigh_end_time = formState.kdj_copyrigh_end_time?.format('YYYY-MM-DD HH:mm:ss')
    params.kdj_has_sub_authorized = formState.kdj_has_sub_authorized
  }
  kdjSave(params).then(res => {
    isLoading.value = false
    if (res.code === 0) {
      message.success('保存成功')
      visible.value = false
      emit('success')
    } else {
      message.error(res.msg || res.message || '保存失败')
    }
  }).catch(() => {
    isLoading.value = false
    message.error('保存失败')
  })
}
</script>

